/* eslint-disable padding-line-between-statements */
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './AddressStandardizationComponent.metadata.json5';
import './AddressStandardizationComponent.messages';
import AddressStandardizationService from "./services/AddressStandardizationService";

const AddressStandardizationComponent = (props) => {
    const {
        model,
        onValidate,
        viewModelService,
        onValueChange,
        hideSearch,
        labelPosition,
        hideFields = [], readOnlyFields = [], requiredFields = [],
        isModelValidation,
        contactVM,
        readOnly
    } = props;
    const [accessToken, setAccessToken] = useState(null)
    const [addressVM, setAddressVM] = useState(null);
    const [availableAddress, setAvailableAddress] = useState();
    const [selectedAddress, setSelectedAddress] = useState();
    const [addressRange, setAddressRange] = useState();
    const restoreSearchValue = false;
    const fields = [
        'addressLine1',
        'addressLine2',
        'addressLine3',
        'city',
        'state',
        'country',
        'postalCode',
        'addressType',
        'addressDescription'
    ];

    const writeValue = useCallback((value, path) => {
        if (addressVM) {
            const addressModel = viewModelService.clone(addressVM);

            _.set(addressModel, path, value);

            if(onValueChange){
                onValueChange(value, path)
            }

            setAddressVM(addressModel);
        }
    }, [addressVM, onValueChange, viewModelService]);

    useEffect(() => {
        /* if(!accessToken){
            AddressStandardizationService.getAddressStandardizationAccessToken().then( (token) => {
                if(token) {setAccessToken(token)}
            }).catch(() => {
                _.noop()
            });
        } */

        // if(model){
            const _xCenter = 'pc';
            const _dtoName = 'edge.capabilities.address.dto.AddressDTO';
            const data = model.value || model;
            const addressDetailsVM = model.value ? model : viewModelService.create( data, _xCenter,  _dtoName);
            if(!isModelValidation){
                _.set(addressDetailsVM, 'isFromPortal.value', true);
               // _.set(addressDetailsVM, 'isValidationRequired.value', true);
            }            
            setAddressVM(addressDetailsVM);
        // }
        
    }, [accessToken, isModelValidation, model, viewModelService]);

    const onAddressSelect = (value) => {
        const addressSelected = availableAddress.filter((addressData) => addressData.code === value);

        if(addressSelected && addressSelected.length > 0){
            const changedAddress = addressSelected[0]

            const addressModel = viewModelService.clone(addressVM);

            if(changedAddress.ranges.length > 1){
                const ranges = _.map(changedAddress.ranges, (range) => {
                    const addressLine1 = range.units[0].formattedUnitAddress.split(',')[0];
                    return {
                        code: addressLine1,
                        name: addressLine1
                    }
                });
                _.set(addressModel, 'addressLine1', '');
                setAddressRange(ranges);
            } else {
                setAddressRange([])
                _.set(addressModel, 'addressLine1', changedAddress.addressLine1);
            }

            _.set(addressModel, 'addressLine2', changedAddress.addressLine2);
            _.set(addressModel, 'city', changedAddress.city);
            _.set(addressModel, 'state', changedAddress.state);
            _.set(addressModel, 'postalCode', changedAddress.postalCode);
            _.set(addressModel, 'displayName', changedAddress.name);

            if(onValueChange){
                onValueChange(addressModel.value, '')
            }

            setAddressVM(addressModel);
            setSelectedAddress(changedAddress.name);
        }

    }

    const loadAddress = async (searchText) => {
        if(accessToken && searchText && searchText.length > 3){            
            const response = await AddressStandardizationService.getStandardAddress(accessToken, {searchText})
    
            const locations =  response.location.map((location) => {
                const addressData = location.address;
                const addressLine1 = addressData.placeName ? `${addressData.placeName}-${addressData.mainAddressLine}` : addressData.mainAddressLine

                return {
                    code: addressData.formattedAddress.replace(/ /g, ''),
                    name: addressData.formattedAddress,
                    addressLine1,
                    addressLine2: '',
                    city: addressData.areaName3,
                    state: addressData.areaName1,
                    postalCode: addressData.postCode,
                    ranges: location.ranges
                }
            });

            setAvailableAddress(locations);

            return locations;
        }

        return []

    }

    const onRangeChange = (value, path) => {
        setAddressRange([]);
        writeValue(value, path);
    }

    const generateOverrides = () => {
        const overrides = fields.map((field) => ({
                [`${field}`]: {
                    visible: hideFields.indexOf(field) === -1,
                    readOnly: readOnlyFields.indexOf(field) !== -1 || readOnly,
                    required: requiredFields.indexOf(field) !== -1,
                }
            }));
        return Object.assign({}, ...overrides);
    }
   
    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true,
            labelPosition: labelPosition || 'top'
        },
        // addressLine3: {
        //     visible: false
        // },
        addressType: {
            visible: !!(addressVM && addressVM.addressType)
        },
        addressSearch: {
            onLoadValues: loadAddress,
            onValueChange: onAddressSelect,
            availableValues: availableAddress,
            value: restoreSearchValue ? selectedAddress : '',
            visible: false //! hideSearch
        },
       addressLine1Range:{
            visible: !!(addressRange && addressRange.length > 0),
            availableValues: addressRange,
            onValueChange: onRangeChange
        },
        addressLine1:{
            visible: !(addressRange && addressRange.length > 0),
        },
        ...generateOverrides()
    };

    return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={addressVM}
                overrideProps={overrideProps}
                onValueChange={writeValue}
                onValidationChange={onValidate}
            />
    );
};

AddressStandardizationComponent.propTypes = {
    viewModelService: PropTypes.shape({
        create: PropTypes.func.isRequired,
        clone: PropTypes.func.isRequired,
    }).isRequired,
    model: PropTypes.shape({}).isRequired,
    onValidate: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
};

export default AddressStandardizationComponent;
